const getFileName = (path?: string) => {
  if (!path) return '';
  return path.split('/').slice(-1).join().split('.')
    .shift();
};

export default getFileName;
